import { CalendarClock, ArrowRight } from "lucide-react";
import { DotField } from "./decor";
import { WORKSHOP_AGENDA } from "../data";
import { Reveal, SectionLabel, CTAButton } from "./primitives";

export const Workshop = () => (
  <section id="workshop" data-testid="workshop-section" className="relative overflow-hidden bg-[#F4F6F0] py-24 md:py-32">
    <div className="pointer-events-none absolute right-0 top-0 h-80 w-80 rounded-full bg-brand/10 blur-[130px]" />
    <div className="mx-auto max-w-7xl px-6 md:px-8">
      <div className="grid gap-14 lg:grid-cols-2 lg:items-center">
        <Reveal>
          <SectionLabel>Strategic Launchpad</SectionLabel>
          <h2 className="mt-4 font-serif text-3xl font-medium tracking-tight text-[#23271F] sm:text-4xl lg:text-5xl">
            The 1-Day Executive Alignment Workshop
          </h2>
          <p className="mt-4 font-serif text-lg italic text-[#5C8A1E]">
            Align your leadership team. Sharpen your strategy. Accelerate your revenue engine.
          </p>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-[#4c5445] sm:text-base">
            A focused, high-intensity executive session to align on strategy, ICP, route-to-market,
            and enterprise sales execution — culminating in a practical transformation roadmap
            tailored to your business.
          </p>
          <div className="mt-8">
            <CTAButton testId="workshop-cta" href="#contact">
              Reserve a Workshop Slot <ArrowRight className="h-4 w-4" />
            </CTAButton>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="rounded-2xl border border-line bg-white shadow-[0_6px_28px_rgba(28,38,18,0.06)] p-8">
            <div className="mb-6 flex items-center gap-3 text-[#5C8A1E]">
              <CalendarClock className="h-5 w-5" />
              <span className="text-xs font-semibold uppercase tracking-[0.18em]">Agenda Snapshot</span>
            </div>
            <ol className="space-y-4">
              {WORKSHOP_AGENDA.map((item, i) => (
                <li key={i} className="flex items-center gap-4 border-b border-line/60 pb-4 last:border-0 last:pb-0">
                  <span className="font-serif text-lg font-semibold tabular-nums text-[#b8c1a8]">
                    0{i + 1}
                  </span>
                  <span className="text-sm font-medium text-[#3d4436]">{item}</span>
                </li>
              ))}
            </ol>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
